import CASL from '@/utils/constants/casl'

export default [
  {
    path: 'welcome-voucher',
    name: 'loyalty.welcome-voucher',
    meta: {
      title: 'Welcome Voucher',
      action: 'read',
      subject: CASL.ACCESS.WELCOME_VOUCHER
    },
    component: () => import('./list/WelcomeVoucherListPage.vue')
  },
  {
    path: 'welcome-voucher/add',
    name: 'loyalty.welcome-voucher.add',
    meta: {
      title: 'Welcome Voucher Add',
      action: 'create',
      subject: CASL.ACCESS.WELCOME_VOUCHER
    },
    component: () => import('./form/WelcomeVoucherFormPage.vue')
  }
]
